// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__2aFd5","icon":"styles_icon__18fDx"};